import {Box, Card, Chip, css, styled} from '../../../ui-library';
import {statusChipsStyle} from '../../AutoProjectImageCollectionTab/Style/AutoProjectImageCollectionTab.style';

export const CardContainer = styled(Card)`
    width: 100%;
    height: 460px;
`;


export const ClassesStatusBox = styled(Box)`
    width: 100%;
    height: 377px;
    border: 1px solid #D1D5DB;
    border-radius: 10px;
    background: #F8F9F9;
    margin-bottom: 16px;
`;

export const CardTitleBox = styled(Box)`
    display: flex;
    flex-direction: row;
    height: 36px;
    margin-bottom: 14px;
    justify-content: space-between;
    align-items: center;
`;

export const CollectionStatusChip = styled(Chip)<{ chipstyle: any }>`
    ${({ theme, chipstyle }) => css`
        background-color: ${statusChipsStyle[chipstyle] && statusChipsStyle[chipstyle].bgColor({ theme })};
        height: 32px;
        margin-bottom: 13px;
        & .MuiChip-label {
            font-weight: 500;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 0.16px;
            color: ${statusChipsStyle[chipstyle] && statusChipsStyle[chipstyle].textColor({ theme })};
        }
    `}
`;

export const ChipsBox = styled(Box)`
    margin: 0px 7.3px 0px 16px;
    padding-top: 16px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 13px;
    max-height: 100%;
    overflow-y: auto;
    padding-right: 16px;

    ::-webkit-scrollbar {
        width: 4px;
    }
    ::-webkit-scrollbar-track {
        margin-block: 20px;
        background: #F8F9F9;
    }
    ::-webkit-scrollbar-thumb {
        background: #D1D5DB;
        border-radius: 7px;
    }
`;
